import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.promise.finally.js";
import React from 'react';
import { mediaErrorType, MediaErrorType, MediaSupport, MediaTrackType } from "../view-model";
import { useMediaSupport } from "./use-media-support.hook";
export const useMediaStream = constraints => {
  const support = useMediaSupport(MediaSupport.USER_MEDIA);
  const [stream, setStream] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [called, setCalled] = React.useState(false);
  const [data, setData] = React.useState({
    audio: {},
    video: {}
  });
  const supports = React.useCallback((type, properties) => {
    if (called && stream) {
      const [track] = type === MediaTrackType.VIDEO_INPUT ? stream.getVideoTracks() : stream.getAudioTracks();
      if (track) {
        const settings = track.getSettings();
        return properties.every(property => property in settings);
      } else return false;
    } else return false;
  }, [stream]);
  const userMedia = React.useCallback(() => {
    if (support) {
      setError(null);
      setLoading(true);
      close();
      navigator.mediaDevices.getUserMedia(constraints !== null && constraints !== void 0 ? constraints : {
        audio: true,
        video: true
      }).then(s => {
        const [audio] = s.getAudioTracks();
        const [video] = s.getVideoTracks();
        setData({
          audio: audio ? audio.getSettings() : {},
          video: video ? video.getSettings() : {}
        });
        setStream(s);
      }).catch(e => setError(e)).finally(() => setLoading(false));
    } else {
      setError(mediaErrorType(MediaErrorType.NOT_SUPPORTED_USER_MEDIA));
    }
  }, [constraints]);
  const close = React.useCallback(() => {
    if (stream) {
      stream.getTracks().forEach(track => {
        // stream.removeTrack(track)
        track.stop();
      });
    }
  }, [stream]);
  const open = React.useCallback(() => {
    setCalled(true);
    userMedia();
  }, [userMedia]);
  React.useEffect(() => {
    return () => close();
  }, [close]);
  React.useEffect(() => {
    if (called) userMedia();
  }, [constraints]);
  return [open, close, {
    stream,
    error,
    loading,
    called,
    data,
    supports
  }];
};